import React from 'react';
import { Button, FormControl } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import ModelDataModel from '../../models/model/ModelDataModel';
import launchAirflowDag from '../../utils/launch_airflow_dag';

type AudienceFilterHeaderComponentProps = {
  tenant: number;
  model: ModelDataModel;
  isSuperKudu: boolean;
  audiencesNames: string[];
  selectedAudienceName: string;
  handleOnAudienceNamesChange: Function;
};

export default class AudienceFilterHeaderComponent extends React.Component<
  AudienceFilterHeaderComponentProps,
  {}
> {
  constructor(props: AudienceFilterHeaderComponentProps) {
    super(props);
    this.handleOnClickCompute = this.handleOnClickCompute.bind(this);
  }

  async handleOnClickCompute() {
    const { model, tenant } = this.props;
    const { type } = model;

    const dag: string =
      type === 'customer_fit'
        ? `customer_fit_performance_${tenant}`
        : `behavioral_performance_report_${tenant}`;
    await launchAirflowDag({
      tenant,
      dagName: dag,
      sectionName: 'performances',
    });
  }

  render() {
    const {
      audiencesNames,
      selectedAudienceName,
      handleOnAudienceNamesChange,
      isSuperKudu,
    } = this.props;

    return (
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light border-top sticky-top box-shadow-3d d-flex justify-content-between"
        aria-label="breadcrumb"
      >
        <ul className="navbar-nav mt-2 mt-lg-0 w-75">
          <span className="font-weight-bold breadcrumb-item mt-1 mb-0">
            Filters
          </span>
          <div className="d-flex justify-content-center ml-3 w-100">
            <p className="ml-3 mt-1 mb-0">Audience</p>
            <FormControl
              className="ml-3 w-25"
              componentClass="select"
              value={selectedAudienceName}
              onChange={(event: any) =>
                handleOnAudienceNamesChange(event.target.value)
              }
            >
              {audiencesNames &&
                audiencesNames.map((audienceName, index) => {
                  return (
                    <option key={`audience_name_${audienceName}_${index}`}>
                      {audienceName}
                    </option>
                  );
                })}
            </FormControl>
            <p className="ml-3 mb-0 mt-1 w-100">Timeframe: Last 6 months</p>
          </div>
        </ul>
        <p className="font-italic mb-0 mt-1">
          Data is refreshed on a weekly basis
        </p>
        <ReactTooltip place="left" />
        {isSuperKudu && (
          <Button
            data-tip="Refresh this report"
            className="btn btn-primary my-2 my-lg-0 mx-1"
            id="compute"
            onClick={this.handleOnClickCompute}
          >
            <FontAwesomeIcon icon={faSync} />
          </Button>
        )}
      </nav>
    );
  }
}
